import styled from 'vue-styled-components';
import { FONTS } from '@shared/constants';
import { COLORS } from '@shared/colors';

export const Container = styled.h1`
  text-align: center;
  font-family: ${FONTS.STANLEY};
  font-size: 3em;
  color: ${COLORS.GRAY};
  margin-bottom: 40px;
`;
